import React from 'react';
import Alert from '../../../../../../../shared/design-system/components/alert';
import { Images } from '../../../../../../../shared/app-constants';

const LowerLimitErrorNudge = ({ t, lowerLimitError }) =>
  lowerLimitError ? (
    <div className="mt-2">
      <div>
        <Alert
          contentContainer={
            <span>
              {t('messages.lower_value_limit_then_ramp_up_limit_error')}
            </span>
          }
          variant={Alert.Variant.Danger}
          theme={Alert.Theme.New}
          svgIcon={Images.AlertTriangleRed}
        />
      </div>
    </div>
  ) : null;
export default LowerLimitErrorNudge;
